import { useSyncExternalStore } from 'react'
import { SnapSize, TimerEvent } from '../../constants/enums'
import { THROTTLE_TIMERS } from '../../state'
import { pubSubTimer } from '../../state/pubSub'
import { registerSnaps } from '../../state/state.timers'

const subSnap = (id: number) => (callback: () => void) =>
    pubSubTimer.on(`${TimerEvent.STATE}::${id}`, callback)
const getSnapUrl = (id: number) => () =>
    THROTTLE_TIMERS.snaps[id.toString()]?.srcUrl

export const useSnaps = (id: number, size: SnapSize) => {
    const subbed = getSnapUrl(id)()
    const regSrc = subbed ?? registerSnaps(id, size)
    const src = useSyncExternalStore(
        subSnap(id),
        getSnapUrl(id),
        getSnapUrl(id),
    )
    return src || regSrc
}
